import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'
import Event from '@/views/Event.vue'
import store from '@/store/index';

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: 'Login',
      logLayout: true,
    },
  },
  {
    path: '/',
    name: 'home',
    meta: {
      title: 'Accueil',
      logLayout: false,
    },
    component: Home
  },
  {
    path: '/event/:eventid',
    name: 'event',
    meta: {
      title: 'Nouveau SAV',
      logLayout: false,
    },
    component: Event,
    props: true
  },
  {
    path: '/logs',
    name: 'logs',
    meta: {
      title: 'Logs',
      logLayout: false,
    },
    component: () => import(/* webpackChunkName: "logs" */ '@/views/Logs.vue')

  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

const waitForStorageToBeReady = async (to, from, next) => {
  console.log('waitForStorageToBeReady');
  await store.restored
  next()
}
router.beforeEach(waitForStorageToBeReady)


router.beforeEach((to, from, next) => {
  const token = store.getters['login/getToken'];
  console.log('token', token, to.name);

  if (token === null && to.name !== 'login') {
      next({'name': 'login', replace: true});
  }
  else if (to.name === 'login' && token !== null ) {
       next({'name': 'home', replace: true});
  }else{
    // on cache le loader qui est dans le header
    jQuery('#page-header-loader').removeClass('show');
    next();
  }
});

export default router
